import React from 'react';

import { Table } from 'components/table/Table';
import { Company } from 'libs/api/invest/generated/schema';

import { MappedSection } from '../../dashboardSettingsTypes';
import { getValue } from '../../dashboardSettingsUtils';


export function FundRaisingSummary(props: { company: Company, section: MappedSection}) {
  const components = props.section.components.filter(component => component.checked);
  return (
    <Table
      sectionTitle={'Fund Raising Summary'}
      columns={components.map(c => ({
        label: (props.company.aggregationType || !props.company.aggregationId) && c.aggr_label ? c.aggr_label : c.label
      }))}
      isFirstColumnSticky
      rows={
        props.company.fundInvestments
          .map(fi => fi.investmentMemos.map(im => ({name: `${im.transactionName} - ${fi.fund.name}`, ...im, fi})))
          .flat()
          .map(im => (
            components.map(c => (
              {
                content: getValue(c, im, '', window.GLOBAL_CONFIG.CURRENCIES[im.fi.fund.currency]),
                sortingValue: getValue(
                  c,
                  im,
                  undefined,
                  window.GLOBAL_CONFIG.CURRENCIES[props.company.currency],
                  true,
                ),
              }
            ))
          ))
      }
    />
  )
}
